import React from 'react';
import { MenuDish } from '../constants/type.constant';
import { StateManager } from '../redux/stateManager';
import Store from '../redux/store';
import foodDefaultImage from '../assets/food.png';
import { IconButton } from '@material-ui/core';
import RemoveCircleOutlinedIcon from '@material-ui/icons/RemoveCircleOutlined';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import _ from 'lodash';
import Skeleton from './skeleton/skeleton.conponent';
import { allergen, preLoadNginxImage } from '../tools/utils';
import RestoreOutlinedIcon from '@material-ui/icons/RestoreOutlined';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import i18n from '../i18n';
import ServerShoppingCart from '../modules/server-shopping-cart';
const bargainIcon = require('../assets/bargain-icons/QOP-normal-bargain-icon.png');
const allergenFilterIcon = require('../assets/allergen-filter-icon/QOP-normal-allergen-filter-icon.png');
// 加入或移出购物车
enum UPGRADE {
    REMOVE_DISH = -1,
    ADD_DISH = 1,
}
class LeftBarDishItem extends React.Component<Props, State> {
    public isShowName1 = true;
    public state: State = {
        dishImg: ''
    }

    // *********************
    // Life Cycle Function
    // *********************
    UNSAFE_componentWillMount() {
        // 预加载图片
        this.preloadImage();
        const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2');
        if (findRes) this.isShowName1 = findRes.value.showItemName1
    }
    componentDidMount() {

    }
    async componentDidUpdate(perProps: Props) {
        if (!_.isEqual(perProps.item, this.props.item)) {
            // 预加载图片
            await this.preloadImage();
        }
    }

    // *********************
    // Default Function
    // *********************

    public getSettingInfoValue(str: string) {
        const SETTING = StateManager.getFromCache('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    async preloadImage() {
        let storeState = Store.getState()
        let dishImg = `${storeState.serverUrl}/menu_pic/${this.props.item?.item_id}_s.jpg`;
        const newImage = await  preLoadNginxImage(dishImg, '/menu_pic', '', true);
        this.setState({
            dishImg: newImage || foodDefaultImage
        })
    }

    // *********************
    // View
    // *********************

    render() {
        const { item, changeMenuQuantity, openMenuDetail, liteMode, currency_name } = this.props;
        const { dishImg } = this.state;
        const foodName = this.isShowName1 ? item.item_name1 : item.item_name2;
        //  这个模式不需要 显示历史数量 + 当前数量
        const quantity = item.quantity || 0;
        // 历史数量
        const historyQuantity = item.history_num || 0;
        // 套餐
        const isSetMenu = item.item_type === 3;
        // isBusinessTime 为true则不在营业时间内
        const isBusinessTime = Store.getState().isBusinessTime;
        // 菜品标识数组
        const dishIdentsArrs = item.allergen.concat(item.other_detail_info).slice(0, 5);
        // 过敏原 & 菜品标识过滤器标识
        const filterFlag: boolean = ServerShoppingCart.getAllergensAndIngredentsFilterFlag(item);
        // 是否为沽清菜品
        const isBargainDish = [1, 3].includes(Number(item.bargain_stype)) || (Number(item.bargain_stype) === 2 && typeof(item.bargain_num_cur) !== 'number');
        // 是否为数量沽清菜品
        const isNumBargainDish = (Number(item.bargain_stype) === 2 && typeof(item.bargain_num_cur) === 'number');
        // 菜品描述
        let desc = _.get(item, 'item_description', '');
        let extDishInfo = _.get(item, 'ext_dish_info', '');
        return (
            <div className='left-bar-dish-item-box'>
                {/* 菜品沽清 */}
                {
                    (isBargainDish || filterFlag) ?
                        <div className='bargainStype' style={{ justifyContent: 'normal' }} onClick={() => { openMenuDetail() }}>
                            <div style={{ width: '50%', display: 'flex', justifyContent: 'center' }}>
                                {
                                    isBargainDish ? 
                                        <div className='mask-icon-box'>
                                            {/* <RoomServiceIcon />
                                            <CloseIcon className=' bargain-icon' /> */}
                                            <img src={bargainIcon} />
                                        </div>
                                        :
                                        null
                                }
                                {filterFlag && <div className='mask-icon-box'><img src={allergenFilterIcon} style={{ width: 40, height: 40 }} /></div>}
                            </div>
                        </div>
                        :
                        null
                }
                <div className='dishImgbox' onClick={() => { openMenuDetail() }}>
                    {/* 数量沽清标识 */}
                    {isNumBargainDish ? 
                        <div className={`set-menu-bargain-icon-box ${item.allergen?.length > 0 ? 'set-menu-bargain-allergen-icon-box' : ''}`}>
                            {
                                item.quantity > 0 ?
                                <div className='bargain-badge-box'>
                                    <img className='bargain-badge-icon' src={bargainIcon} />
                                    <div className={`text ${item.quantity > 0 ? 'active' : 'not-active'}`} style={{ marginLeft: 5 }}>
                                    {`${item.quantity}`}
                                    </div>
                                    <div className={`text ${item.quantity > 0 ? 'active_3' : ''}`}>
                                        {`/${item.bargain_num_cur}`}
                                    </div>                                                                                                                                                                          
                                </div>
                                :
                                <img className='bargain-badge-icon' src={bargainIcon} />
                            }
                        </div>
                        :
                        null
                    }
                    {/* 套餐标识 */}
                    {isSetMenu && <div className='set-menu-icon-box'>{i18n.t('menu_page_text_setMenu')}</div>}
                    <Skeleton show={!dishImg}>
                        <img className='dishImg' src={dishImg} alt='' />
                    </Skeleton>
                    {/* 过敏原 */}
                    <div className='allergen-box'>
                        {
                            dishIdentsArrs?.map((allergyItem, index) => (
                                <>
                                    {
                                        index > 3 ?
                                            <MoreHorizIcon className='allerrgen-omit-icon' />
                                            :
                                            <img className='allergen-img' src={allergen(allergyItem)} alt={allergyItem} key={index} />
                                    }
                                </>

                            ))
                        }
                    </div>
                    {/* 曾经点过菜 */}
                    {
                        historyQuantity
                            ? <div className='history-order-icon-box'>
                                <RestoreOutlinedIcon className='history-order-icon' />
                            </div> : null
                    }
                </div>
                <div
                    className='content'
                    style={(isBusinessTime && item.not_joining_global_limit !== 1) ? { background: '#ffffff4d', pointerEvents: 'none' } : {}}
                >
                    <div>
                        <div className='dishListtitle center'>
                            <p>{foodName}</p>
                        </div>
                        {
                            (_.trim(`${desc}`).length > 0 || _.trim(`${extDishInfo}`).length > 0) &&
                            <div className='dishListdescription center' >
                                <p>{extDishInfo} {desc}</p>
                            </div>
                        }
                    </div>
                    <div className='pricebox'>
                        <p className='priceboxprice'>
                            <span>{item.price_1 && item.price_1?.toFixed(2)}{currency_name}</span>
                        </p>
                        {!liteMode && < div className='priceNumber'>

                            {isSetMenu ? <span /> :
                                <IconButton
                                    onClick={(evt) => {
                                        evt.stopPropagation();
                                        changeMenuQuantity(item, UPGRADE.REMOVE_DISH)
                                    }}>
                                    <RemoveCircleOutlinedIcon
                                        className={`AiFillMinusCircle animate-fadeIn ${quantity ? '' : 'no-number-circle'} ${(isBusinessTime && item.not_joining_global_limit !== 1) ? 'AiFillMinusCircleDisabledBtn' : ''}`}
                                    />
                                </IconButton>}
                            {isSetMenu ? <span /> : <p className={`number animate-fadeIn ${quantity ? 'number' : 'is_no_number'}`}>
                                {quantity}
                            </p>}
                            <IconButton onClick={(evt) => {
                                evt.stopPropagation();
                                if (isSetMenu) {
                                    this.props.openSetDishDetail();
                                } else {
                                    changeMenuQuantity(item, UPGRADE.ADD_DISH)
                                }
                            }}>
                                <AddCircleOutlinedIcon
                                    className={`AiFillPlusCircle ${quantity && !isSetMenu ? 'plus-icon-has_number' : ''}${(isBusinessTime && item.not_joining_global_limit !== 1) ? 'AiFillMinusCircleDisabledBtn' : ''}`}
                                />
                            </IconButton>
                        </div>}
                    </div>
                </div>
                <div className='clickBox' onClick={() => { openMenuDetail() }}></div>
            </div >
        )
    }
}
export default LeftBarDishItem

// *********************
// State & Props
// *********************

type State = {
    dishImg: string;
}

type Props = {
    item: MenuDish & {
        history_num?: number | undefined;
    };
    /**
     * 更新购物车
     * @param dish 菜品数据`Dish`
     * @param type 操作类型` UPGRADE_OPERATES`
     */
    changeMenuQuantity(dish: MenuDish, type: UPGRADE, expandDish?: MenuDish): void;
    // 打开菜品大图
    openMenuDetail(): void
    // 简洁版
    liteMode: boolean;
    // 打开套餐详情弹窗
    openSetDishDetail(): void;
    // 货币文本
    currency_name: string;
}
